import React, { useState, useEffect } from 'react';
import { 
    Box, 
    Button,
    Card, 
    Container, 
    Fade, 
    makeStyles,     
    Typography,
    Slider
} from '@material-ui/core';
import { Skeleton, Rating } from '@material-ui/lab'
import Layout from '../../components/Layout/Layout';
import ReviewCard from '../../components/ReviewCard/ReviewCard';
import { themeGreen } from '../../theme';
import GradeIcon from '@material-ui/icons/Grade';

const useStyles = makeStyles(theme => ({    
    CustomCard : { marginBottom: '20px', maxWidth: '360px', margin: 'auto' },
    Container: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center'
    },
    MainWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        maxWidth: '600px',
        marginTop: theme.spacing(6),
        marginBottom: theme.spacing(10),
        [theme.breakpoints.down('md')]: {
            maxWidth: 'initial'
        }
    },
    ContentWrapper: { width : '100%' }, 
    ProductWrapper: {
        marginTop: theme.spacing(3),
        display: 'flex',
        alignItems: 'center'
    },
    ProductAvatar: {
        width: '80px',
        height: '80px',
        flexShrink: 0,
        borderRadius: '100%',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& img': {
            width: 'auto',
            height: '100%'
        }
    },
    ProductInfo: {
        marginLeft: theme.spacing(2)
    },
    LightText: {
        fontWeight: 100
    },
    QuestionText: {
        fontSize: '18px',
        fontWeight: 500,
        marginBottom: theme.spacing(2)
    },
    Title: {
        width: '100%',
        fontSize: '30px',
        fontWeight: 500,
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px',
            lineHeight: 1.3
        }
    },    
    ResumeCard: { padding: theme.spacing(2), width: '100%'},    
    PercentWrapper: { minWidth: '35px'},
    Slider: { width: '75%', flexShrink: 0},
    StarResume: { gap: '15px'},
    CustomSliderRoot: { color: '#fab401', padding: '20px 0', flexGrow: 1, width: "initial"},
    CustomSliderRail: { height: '20px', top: '10px', background: "#bdbdbd" },
    CustomSliderTrack: { height: '20px', top: '10px' },
    CustomSliderThumb: { display: 'none' },
    RatingWidget: { marginLeft: '-3px'},
    TextWrapper: {
        width: '100%',               
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(5)        
    },
    sellNowText: {
        fontSize: '22px',
        lineHeight: '26px',
        fontWeight: 300,
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2)
    },
    MetricNumber : {
        fontSize: '65px',
        marginRight: theme.spacing(3)
    }
}));


function ReviewsList(props) {
    const classes = useStyles(themeGreen);
    const STATIC_URL_1 = 'https://static.aastatic.com.ar/';
    const STATIC_URL_2 = 'https://static2.aastatic.com.ar/';
    const [loading, setLoading] = useState(false);
    const [img, setImg] = React.useState(null);
    const [marca, setMarcaNombre] = React.useState('');
    const [modelo, setModeloNombre] = React.useState('');
    const [rubro, setRubroNombre] = React.useState({
        gen: '',
        nombre: ''
    });
    const [param_r2, setParamR2] = useState(props.match.params['rubro2']);
    const [param_mod, setParamMod] = useState(props.match.params['model']);
    const [reviews, setReviews] = useState([])
    const [stats, setStats] = useState({
        grand_count: 0,
        grand_sum: 0,
        prom: 0,
        rated1: 0,
        rated2: 0,
        rated3: 0,
        rated4: 0,
        rated5: 0
    })
    
    useEffect(() => {
        setLoading(true);
        fetch(`https://django.agroads.com.ar/v1/reviews/?entity_id=1&item_id=${param_mod}`)
            .then(res => res.json())
            .then(data => {
                setReviews(data.results);
            })
            .then(console.log)
            .finally(()=>{
                setLoading(false);
            })
    }, [param_r2, param_mod])

    useEffect(() => {
        window.scrollTo(0, 0);

        if (param_r2 && param_mod) {
            fetch(`https://www.agroads.com.ar/reviews/api/es.asp?action=info&mo=${param_mod}&r2=${param_r2}`)
                .then(res => res.json())
                .then(data => {
                    let info = data.hits.hits[0]["_source"];
                    setRubroNombre({
                        gen: info.rubros.rubro2.sexo,
                        nombre: info.rubros.rubro2.rubro_singular
                    });
                    setMarcaNombre(info.marca.detalle);
                    setModeloNombre(info.modelo.detalle);                    
                })
                .catch(console.log)

            fetch(`https://www.agroads.com.ar/reviews/api/es.asp?action=getimg&mo=${param_mod}&r2=${param_r2}`)
                .then(res => res.json())
                .then(data => {
                    let img_url = `${STATIC_URL_1}img/no-fotos-225x180.png`;
                    if (data.hits.hits && data.hits.hits[0])
                        img_url = `${STATIC_URL_2}${data.hits.hits[0]["_source"].pictures[0].variants["100"].jpg}`  

                    setTimeout(() => {
                        setImg(img_url);
                    }, 500);
                })
                .catch(console.log)
        }
    }, [])

    useEffect(() => {
        let cantidad = reviews.length;
        let rating_sum = 0;
        let ratings = {
            rated1: 0, rated2: 0, rated3: 0, rated4: 0, rated5: 0
        }        
        reviews.forEach(review => {            
            ratings[`rated${review.valuation.toString()}`] ++;            
            rating_sum += review.valuation;
        });

        setStats({ grand_count : cantidad, grand_sum: rating_sum, ...ratings })        
    }, [reviews])

    
    return (
        <Layout loading={loading}>
            <Container maxWidth="md" className={classes.Container}>
                <Box display="flex" width='100%' alignItems="center" className={classes.MainWrapper}>
                    <Fade in={true} timeout={1600}>
                        <div className={classes.ContentWrapper}>
                            <Typography variant='h6'>Reseñas</Typography>
                            <Box width='100%'>
                                <div className={classes.ProductWrapper}>
                                    <div className={classes.ProductAvatar}>
                                        {
                                            img !== null ? <img alt="Imagen producto" src={`${img}`} /> : <Skeleton variant="circle" width={80} height={80} />
                                        }

                                    </div>
                                    <div className={classes.ProductInfo}>
                                        <Typography className={classes.Title}><span className={classes.LightText}>{rubro.nombre.toLowerCase()}</span> {marca} {modelo}</Typography>
                                        {/* <div>
                                            <Rating
                                                className={classes.RatingWidget}
                                                value={(stats.grand_sum / stats.grand_count).toFixed(1)}
                                                size="small"
                                                precision={0.1}
                                                readOnly
                                            />
                                        </div> */}
                                    </div>
                                </div>
                            </Box>
                            <Box display='flex' flexDirection='column' mt={7}>
                                <Box mb={2}>
                                    <Typography variant='h6'>Resumen</Typography>
                                </Box>
                                <Card className={classes.ResumeCard} width='100%'>
                                    <Box className={classes.Metric}>
                                        <Box display='flex' alignItems='center'>
                                            <Box className={classes.MetricNumber}>
                                                {stats.grand_sum && (stats.grand_sum / stats.grand_count).toFixed(1)}
                                            </Box>
                                            <Box>
                                                <div>
                                                    <Rating
                                                        className={classes.RatingWidget}
                                                        value={(stats.grand_sum / stats.grand_count).toFixed(1)}
                                                        size="large"
                                                        precision={0.1}
                                                        readOnly
                                                        />
                                                </div>
                                                <Typography variant='caption'>
                                                    { stats.grand_count 
                                                        ? stats.grand_count > 1 ? 'Promedio entre ' + stats.grand_count  + ' opiniones' : 'Basado en 1 opinión'
                                                        : null
                                                    }
                                                </Typography>
                                            </Box>
                                        </Box>                                        
                                        <Box mt={3}>
                                            <Box display='flex' justifyContent='flex-start' alignItems='center' className={classes.StarResume}>
                                                <Box display='flex' alignItems='center'>
                                                    <Typography variant='body2'>5</Typography>
                                                    <GradeIcon color='disabled' fontSize='small' />
                                                </Box>                                               
                                                <Slider
                                                    className={classes.Slider}
                                                    value={(stats.rated5 * 100 / stats.grand_count).toFixed(0)}
                                                    min={0}
                                                    step={1}
                                                    max={100}                                                    
                                                    readOnly        
                                                    classes={{ root: classes.CustomSliderRoot, rail: classes.CustomSliderRail, track: classes.CustomSliderTrack, thumb: classes.CustomSliderThumb}}                                                                                        
                                                />
                                                <Box display='flex' className={classes.PercentWrapper}>
                                                    <Typography variant='body2'>{stats.rated5 ? (stats.rated5 * 100 / stats.grand_count).toFixed(0) + '%': 0 }</Typography>
                                                </Box>                                 
                                            </Box>
                                            <Box display='flex' justifyContent='flex-start' alignItems='center' className={classes.StarResume}>
                                                <Box display='flex' alignItems='center'>
                                                    <Typography variant='body2'>4</Typography>
                                                    <GradeIcon color='disabled' fontSize='small' />
                                                </Box>
                                                <Slider
                                                    className={classes.Slider}
                                                    value={(stats.rated4 * 100 / stats.grand_count).toFixed(0)}
                                                    min={0}
                                                    step={1}
                                                    max={100}
                                                    readOnly      
                                                    classes={{ root: classes.CustomSliderRoot, rail: classes.CustomSliderRail, track: classes.CustomSliderTrack, thumb: classes.CustomSliderThumb }}                                              
                                                />
                                                <Box display='flex' className={classes.PercentWrapper}>
                                                    <Typography variant='body2'>{stats.rated4 ? (stats.rated4 * 100 / stats.grand_count).toFixed(0) + '%' : 0}</Typography>
                                                </Box>

                                            </Box>
                                            <Box display='flex' justifyContent='flex-start' alignItems='center' className={classes.StarResume}>
                                                <Box display='flex' alignItems='center'>
                                                    <Typography variant='body2'>3</Typography>
                                                    <GradeIcon color='disabled' fontSize='small' />
                                                </Box>
                                                <Slider
                                                    className={classes.Slider}
                                                    value={(stats.rated3 * 100 / stats.grand_count).toFixed(0)}
                                                    min={0}
                                                    step={1}
                                                    max={100}
                                                    readOnly     
                                                    classes={{ root: classes.CustomSliderRoot, rail: classes.CustomSliderRail, track: classes.CustomSliderTrack, thumb: classes.CustomSliderThumb }}                                               
                                                />
                                                <Box display='flex' className={classes.PercentWrapper}>
                                                    <Typography variant='body2'>{stats.rated3 ? (stats.rated3 * 100 / stats.grand_count).toFixed(0) + '%' : 0}</Typography>
                                                </Box>

                                            </Box>
                                            <Box display='flex' justifyContent='flex-start' alignItems='center' className={classes.StarResume}>
                                                <Box display='flex' alignItems='center'>
                                                    <Typography variant='body2'>2</Typography>
                                                    <GradeIcon color='disabled' fontSize='small' />
                                                </Box>
                                                <Slider
                                                    className={classes.Slider}
                                                    value={(stats.rated2 * 100 / stats.grand_count).toFixed(0)}
                                                    min={0}
                                                    step={1}
                                                    max={100}
                                                    readOnly    
                                                    classes={{ root: classes.CustomSliderRoot, rail: classes.CustomSliderRail, track: classes.CustomSliderTrack, thumb: classes.CustomSliderThumb }}                                                
                                                />
                                                <Box display='flex' className={classes.PercentWrapper}>
                                                    <Typography variant='body2'>{stats.rated2 ? (stats.rated2 * 100 / stats.grand_count).toFixed(0) + '%' : 0}</Typography>
                                                </Box>

                                            </Box>
                                            <Box display='flex' justifyContent='flex-start' alignItems='center' className={classes.StarResume}>
                                                <Box display='flex' alignItems='center'>
                                                    <Typography variant='body2'>1</Typography>
                                                    <GradeIcon color='disabled' fontSize='small' />
                                                </Box>
                                                <Slider
                                                    className={classes.Slider}
                                                    value={(stats.rated1 * 100 / stats.grand_count).toFixed(0)}
                                                    min={0}
                                                    step={1}
                                                    max={100}
                                                    readOnly    
                                                    classes={{ root: classes.CustomSliderRoot, rail: classes.CustomSliderRail, track: classes.CustomSliderTrack, thumb: classes.CustomSliderThumb }}                                                
                                                />
                                                <Box display='flex' className={classes.PercentWrapper}>
                                                    <Typography variant='body2'>{stats.rated1 ? (stats.rated1 * 100 / stats.grand_count).toFixed(0) + '%' : 0}</Typography>
                                                </Box>
                                            </Box>

                                        </Box>
                                        
                                    </Box>
                                </Card>                                                      
                            </Box>

                            <Box className={classes.TextWrapper}>                                
                                    <div className={classes.sellNowText}>
                                        ¿Tenés o tuviste este modelo?
                                    </div>
                                    <Button size="large" variant="outlined" color="primary" href={'new'}>Dejá tu opinión</Button>
                            </Box>
                            <Box className={classes.ReviewsWrapper} mt={7}>                                
                                    {
                                        reviews.length > 0 
                                            ? <React.Fragment>
                                                <Box mb={2}>
                                                    <Typography variant='h6'>Comentarios</Typography>
                                                </Box>
                                                {
                                                    reviews.map((r,index) => {
                                                        return (
                                                            <Box mb={2} key={index}>
                                                                <ReviewCard                                                                                                               
                                                                        username={r.reviewer_username}
                                                                        rating={r.valuation}
                                                                        comment={r.comment}
                                                                        p_comment={r.positive_comment}
                                                                        n_comment={r.negative_comment}
                                                                        date_created={r.date_created}
                                                                        pictures={r.pictures}
                                                                />
                                                            </Box>
                                                        )
                                                    })                                                
                                                }                                            
                                            </React.Fragment>
                                            : null
                                    }
                            </Box>
                        </div>
                    </Fade>
                </Box>
            </Container>
        </Layout>
    )
}

export default ReviewsList;